module.exports = __webpack_public_path__ + "img/74A192_041B0D_194C33_235B4C-256px.985b70df.png";